import type { Attachment } from 'pkg/api/models/attachment';

export function getExtension(a: Attachment): string {
	const url = a.url;

	const l = document.createElement('a');
	l.href = url;

	const fileName = l.pathname.split('/').pop().split('.');

	if (fileName.length < 2) {
		return '';
	}

	return fileName[1];
}

/**
 *	The attachment's `url` when it is an http(s) address, otherwise `''`. A
 *	link attachment keeps whatever URL it was created with, and one stored
 *	before the API refused other schemes can be javascript: or data:, so
 *	anything that opens an attachment opens this instead of `url`.
 */
export function webUrl(a: Attachment): string {
	if (!a?.url) {
		return '';
	}

	try {
		const { protocol } = new URL(a.url);

		if (protocol === 'http:' || protocol === 'https:') {
			return a.url;
		}
	} catch {
		// Not an absolute URL, so nothing to open.
	}

	return '';
}
